import { useEffect, useReducer } from 'preact/hooks';
import type { Flow, FlowState } from '../flow';

/** Her-rendert bij elke statuswijziging van de flow. */
export function useFlowState(flow: Flow): FlowState {
  const [, bump] = useReducer((n: number) => n + 1, 0);
  useEffect(() => flow.subscribe(() => bump(undefined)), [flow]);
  return flow.state;
}
